import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, UrlSerializer, UrlTree } from '@angular/router';
import { catchError, map, of, take } from 'rxjs';
import { BackendService } from '../core/services/backend.service';

export const legacyUrlGuardGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  //throw new Error('error');
  const serializer = inject(UrlSerializer);
  const backend = inject(BackendService);

  // helper to rebuild the query string
  const qp = route.queryParams ?? {};
  const qs = Object.keys(qp).length ? `?${new URLSearchParams(qp as Record<string, string>).toString()}` : '';

  // ---- Pattern 1: /company/:companyId/offer/:offerId
  const companyIdRaw = route.paramMap.get('companyId');
  const offerId = route.paramMap.get('offerId');
  if (companyIdRaw && offerId) {
    const companyId = Number(companyIdRaw);
    if (!Number.isFinite(companyId))
      return backend.getCompanySummaryDTOBySlug$(companyIdRaw).pipe(
        take(1),
        map((summary) => serializer.parse(`/steps/${summary.slug}/${offerId}/shopping-cart-step${qs}`)),
        // On lookup error, fall through to normal routing (or swap for a not-found)
        catchError(() => of<true | UrlTree>(true)),
      );

    return backend.getCompanySummaryById$(companyId.toString()).pipe(
      take(1),
      map((summary) => serializer.parse(`/steps/${summary.slug}/${offerId}/shopping-cart-step${qs}`)),
      // On lookup error, fall through to normal routing (or swap for a not-found)
      catchError(() => of<true | UrlTree>(true)),
    );
  }

  // ---- Pattern 2: /company/:slug/series/:seriesId/product/:productId
  const slug = route.paramMap.get('slug');
  const seriesId = route.paramMap.get('seriesId');
  const productId = route.paramMap.get('productId');
  if (slug && seriesId && productId) {
    const target =
      `/steps/${slug}/undefined/shopping-cart-step` +
      `/configurator-step/${seriesId}/${productId}` +
      `/three-product-configuration-step/attribute-editing${qs}`;

    return of(serializer.parse(target));
  }

  // Not a legacy URL we handle → continue normal routing
  return true;
};
